import React, { useState } from "react";
import cn from "classnames";
import styles from "./Faq.module.sass";
import Item from "./Item";
import Dropdown from "../../../components/Dropdown";

const items = [
  {
    title: "Général",
    items: [
      {
        title: "Comment les élèves déposent-ils leurs documents ?",
        content: "Chaque élève accède à un espace personnel sécurisé depuis son ordinateur ou son mobile. Il peut y téléverser ses documents en quelques clics. Vous êtes notifié instantanément pour pouvoir les valider."
      },
      {
        title: "La signature électronique a-t-elle une vraie valeur légale ?",
        content: "Oui, notre solution intègre une signature électronique avancée conforme au règlement eIDAS. Elle a la même valeur juridique qu'une signature manuscrite pour les contrats, conventions et autres documents officiels."
      },
      {
        title: "Peut-on générer automatiquement des documents comme les CERFA ?",
        content: "Absolument. Edutio pré-remplit automatiquement les documents récurrents comme les contrats d'apprentissage (CERFA) ou les certificats de réussite avec les informations de l'apprenant, vous faisant gagner un temps précieux."
      },
      {
        title: "Les données sont-elles vraiment en sécurité ?",
        content: "La sécurité est notre priorité. Toutes les données sont chiffrées, stockées sur des serveurs sécurisés en France, et nous effectuons des sauvegardes quotidiennes. Vous gardez un contrôle total sur qui peut voir ou modifier chaque document."
      },
    ],
  },
];

const Team = () => {
  const options = [];
  items.map((x) => options.push(x.title));

  const [category, setCategory] = useState(options[0]);

  return (
    <div className={cn("section", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.top}>
          <div className={cn("stage-small", styles.stage)}>
            Questions fréquentes
          </div>
          <h2 className={cn("h2", styles.title)}>FAQ – Questions fréquentes</h2>
          <div className={styles.info}>
            Découvrez les réponses aux questions les plus courantes sur notre solution d'émargement numérique ou <a href="/contact">Contactez notre support</a>
          </div>
          <div className={styles.nav}>
            {items.map((x, index) => (
              <button
                className={cn(styles.btn, {
                  [styles.active]: x.title === category,
                })}
                onClick={() => setCategory(x.title)}
                key={index}
              >
                {x.title}
              </button>
            ))}
          </div>
          <Dropdown
            className={styles.dropdown}
            value={category}
            setValue={setCategory}
            options={options}
          />
        </div>
        <div className={styles.list}>
          {items
            .find((x) => x.title === category)
            .items.map((x, index) => (
              <Item item={x} key={index} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default Team;
